document.addEventListener("DOMContentLoaded", function () {
  let observer;

  function initializeScript() {
    // Use failsafe selectors
    const submitButton =
      document.querySelector(".product-form__submit--mobile") ||
      document.querySelector(".product-form__submit--exclusive--mobile");
    if (!submitButton) {
      console.error("Submit button not found");
      return;
    }

    const submitButtonContainer =
      submitButton.closest(".product__info-container") ||
      submitButton.parentElement;
    if (!submitButtonContainer) {
      console.error("Submit button container not found");
      return;
    }

    function calculateRootMargin() {
      const viewportHeight = window.innerHeight;
      const containerRect = submitButtonContainer.getBoundingClientRect();
      const containerTop = containerRect.top;
      const marginTop = Math.max(
        containerTop - viewportHeight,
        -viewportHeight
      );
      return `${marginTop}px 0px 0px 0px`;
    }

    observer = new IntersectionObserver(
      ([entry]) => {
        submitButton.classList.toggle(
          "product-form__submit--fixed",
          !entry.isIntersecting
        );
      },
      {
        threshold: 0,
        rootMargin: calculateRootMargin(),
      }
    );

    observer.observe(submitButtonContainer);

    // Recalculate rootMargin on window resize
    window.addEventListener("resize", handleResize);
  }

  function handleResize() {
    if (window.innerWidth <= 1025) {
      if (observer) {
        observer.disconnect();
      }
      initializeScript();
    } else {
      cleanup();
    }
  }

  // Cleanup function
  function cleanup() {
    if (observer) {
      observer.disconnect();
    }
    const submitButton =
      document.querySelector(".product-form__submit--mobile") ||
      document.querySelector(".product-form__submit--exclusive--mobile");
    if (submitButton) {
      submitButton.classList.remove("product-form__submit--fixed");
    }
  }

  // Initial check and setup
  if (window.innerWidth <= 1025) {
    initializeScript();
  }

  // Handle window resizes
  window.addEventListener("resize", handleResize);

  // Cleanup on page unload
  window.addEventListener("unload", cleanup);

  const alternateAddToCartButton = document.querySelector(
    ".add-to-cart--alternate"
  );
  const primaryButton = document.querySelector(".product-form__submit");

  if (alternateAddToCartButton && primaryButton) {
    alternateAddToCartButton.addEventListener("click", function (event) {
      event.preventDefault();
      primaryButton.click();
    });
  } else {
    console.error("Alternate add to cart button or submit button not found");
  }
});

// Force a layout recalculation after a short delay
setTimeout(() => {
  window.dispatchEvent(new Event("resize"));
}, 100);
